var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var styles = {
    container: {
        width: '100%',
        borderRadius: '100%',
        textAlign: 'center',
        height: '100%',
        display: 'table',
    },
    p: {
        display: 'table-cell',
        verticalAlign: ' middle',
        color: '#fff',
    },
};
var LetterAvatar = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'A' : _b, _c = _a.size, size = _c === void 0 ? 36 : _c;
    var letter = name[0].toUpperCase();
    return (React.createElement("div", { style: { height: size, width: size } },
        React.createElement("div", { style: __assign(__assign({}, styles.container), { background: getLetterColor(letter) }) },
            React.createElement("p", { style: styles.p }, letter))));
};
export default LetterAvatar;
var colors = ['#60B389', '#DE6760', '#5CA6D9', '#BD83D4', '#EBB83A'];
var getLetterColor = function (letter) {
    var charCode = letter.charCodeAt(0);
    if (charCode < 70)
        return colors[0];
    if (charCode < 75)
        return colors[1];
    if (charCode < 80)
        return colors[2];
    if (charCode < 85)
        return colors[3];
    return colors[4];
};
